const types = new Map();

function defineType(item) {
    types.set(item.id.toUpperCase(), item)
}

const phaseTypes = {

    WarmUp: 'warmUp',
    CoolDown: 'coolDown',
    StepTest: 'stepTest',
    IntervalTest: 'intervalTest',
    FiveOneFiveTest: 'fiveOneFiveTest',
    RestingSettleIn: 'restingSettleIn',
    RestingMeasurement: 'restingMeasurement',

    find(type) {
        let found = types.get(type.toUpperCase());
        return found ?? {
            id: type,
            label: type,
            color: '#1b82c9',
        };
    }
};


let idx = 0;

defineType({
    id: phaseTypes.WarmUp, order: idx++,
    label: 'Warm Up', color: '#20b306'
});
defineType({
    id: phaseTypes.CoolDown, order: idx++,
    label: 'Cool Down', color: '#20b306'
});
defineType({
    id: phaseTypes.StepTest, order: idx++,
    label: 'Test', color: '#20b306'
});
defineType({
    id: phaseTypes.FiveOneFiveTest, order: idx++,
    label: 'Test', color: '#20b306'
});
defineType({
    id: phaseTypes.IntervalTest, order: idx++,
    label: 'Test', color: '#20b306'
});
defineType({
    id: phaseTypes.RestingMeasurement, order: idx++,
    label: 'Measurement', color: '#20b306'
});
defineType({
    id: phaseTypes.RestingSettleIn, order: idx++,
    label: 'Settle In', color: '#20b306'
});


export default phaseTypes